import React, {useState, useEffect} from 'react';
import {useLocation} from 'react-router';
import {getLocationPath, setLocationPath} from './utils';

export interface RouteContextValue {
    to: string;
    from: string;
}

export const RouterContext = React.createContext<RouteContextValue>({to: null, from: null});

const RouterProvider = ({children}) => {
    const location = useLocation();
    const [route, setRoute] = useState({to: null, from: null});

    useEffect(() => {
        const lastKnownLocation = getLocationPath();
        const currentLocation = location.pathname;

        setRoute(prev => {
            let prevLocation;

            if (prev.to !== currentLocation) {
                prevLocation = prev.to;
            }

            let from = prevLocation || lastKnownLocation;
            if (from === currentLocation) {
                from = '/overview';
            }

            return {to: currentLocation, from};
        });

        setLocationPath(currentLocation);
    }, [location]);

    return <RouterContext.Provider value={route}>{children}</RouterContext.Provider>;
};

export const withRouterProvider = WrappedComponent => props => {
    return (
        <RouterProvider>
            <WrappedComponent {...props} />
        </RouterProvider>
    );
};

export default RouterProvider;
